export enum RoutineTestGender {
  M = 'M',
  MN = 'M(N)',
  F = 'F',
  FS = 'F(S)',
}
